var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUpBg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 826,
    height: 949,
    viewBox: "0 0 826 949",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M413.183-.345l-760.164 1000H-39.12l452.302-595.002 452.302 595.001h307.862z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
export default SvgArrowUpBg;